module.exports = __webpack_public_path__ + "img/whatsapp_contact.7bf88e7a.png";